const HorizontalDistributeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M2 22V2H4V22H2ZM10.5 17V7H13.5V17H10.5ZM20 22V2H22V22H20Z" fill="#1A2547" />
    </svg>
  );
};

export default HorizontalDistributeIcon;
